import React from "react";

const ModifiedByToaster = ({ title, subTitle }) => {
  return (
    <div className="modified-by-toast">
      <div>
        <p>{title}</p>
        <p>{subTitle}</p>
      </div>
    </div>
  );
};

export default ModifiedByToaster;
